import '../styles/layout/header.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer-info">
        주식회사 대덕파트너스
        <br />
        Security Patrol Management System
      </p>
    </footer>
  );
};

export default Footer;
